import { useEffect, useState, useCallback } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

const imgSrc = (u) => (u && u.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export const Lightbox = ({ photos, index, onClose, onStep }) => {
  const close = useCallback(() => onClose(), [onClose]);

  useEffect(() => {
    if (index === null || !photos.length) return;
    const onKey = (e) => {
      if (e.key === "Escape") close();
      if (e.key === "ArrowRight") onStep(1);
      if (e.key === "ArrowLeft") onStep(-1);
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [index, photos.length, close, onStep]);

  if (index === null || !photos.length) return null;

  return (
    <div
      data-testid="lightbox"
      role="dialog"
      aria-modal="true"
      aria-label="Expanded photo"
      className="fixed inset-0 z-50 backdrop-blur-sm flex items-center justify-center p-4 sm:p-10"
      style={{ backgroundColor: "color-mix(in srgb, var(--forest-dark) 88%, black)" }}
      onClick={close}
    >
      <button
        type="button"
        onClick={close}
        data-testid="lightbox-close"
        aria-label="Close"
        className="absolute top-4 right-4 text-white/80 hover:text-white bg-white/10 hover:bg-white/20 rounded-lg p-2.5 transition-colors"
      >
        <X size={20} />
      </button>
      {photos.length > 1 && (
        <>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onStep(-1); }}
            data-testid="lightbox-prev"
            aria-label="Previous photo"
            className="absolute left-3 sm:left-6 top-1/2 -translate-y-1/2 text-white/80 hover:text-white bg-white/10 hover:bg-white/20 rounded-lg p-2.5 transition-colors"
          >
            <ChevronLeft size={22} />
          </button>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onStep(1); }}
            data-testid="lightbox-next"
            aria-label="Next photo"
            className="absolute right-3 sm:right-6 top-1/2 -translate-y-1/2 text-white/80 hover:text-white bg-white/10 hover:bg-white/20 rounded-lg p-2.5 transition-colors"
          >
            <ChevronRight size={22} />
          </button>
        </>
      )}
      <img
        src={imgSrc(photos[index])}
        alt={`Photo ${index + 1} expanded`}
        data-testid="lightbox-image"
        className="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      />
      <span className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white/60 text-xs font-mono">
        {index + 1} / {photos.length}
      </span>
    </div>
  );
};
